export default __webpack_public_path__ + "static/media/filter_icon_spa.25022a65.svg";